import { Location } from '@angular/common';
import { ProgressSpinnerModule } from 'primeng/progressspinner';

import { CommonModule } from '@angular/common';
import { ActivatedRoute } from '@angular/router';
import {
  Component,
  HostListener,
  QueryList,
  ViewChildren,
} from '@angular/core';
import { DataService } from 'src/app/services/data.service';
import { GlobalConstants } from 'src/app/services/global-constants';
import { ToastModule } from 'primeng/toast';
import { MessagesModule } from 'primeng/messages';
import { FormsModule } from '@angular/forms';
import { SafeHTMLPipeStandAlone } from 'src/app/misc/pipes/safe-html-standalone.pipe';
import { ButtonModule } from 'primeng/button';
import { RadioButtonModule } from 'primeng/radiobutton';
import { DropdownModule } from 'primeng/dropdown';
import { CheckboxModule } from 'primeng/checkbox';
import { RatingModule } from 'primeng/rating';
import { TableModule } from 'primeng/table';
import { CalendarModule } from 'primeng/calendar';
import { ProgressBarModule } from 'primeng/progressbar';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { ConfirmationService, MessageService } from 'primeng/api';
import { TranslatorPipeStandAlone } from 'src/app/services/translator.pipe.standalone';
import { QuestionTemplateComponentStandAlone } from '../question-template-standalone/question-template-standalone.component';

@Component({
  standalone: true,
  imports: [
    CommonModule,
    ProgressSpinnerModule,
    ToastModule,
    MessagesModule,
    FormsModule,
    ButtonModule,
    RadioButtonModule,
    DropdownModule,
    CheckboxModule,
    RatingModule,
    TableModule,
    CalendarModule,
    ProgressBarModule,
    ConfirmDialogModule,
  ],
  selector: 'app-survey-view',
  templateUrl: './survey-view.component.html',
  styleUrls: [
    './survey-view.component.scss',
    './survey-view-two.component.scss',
  ],
  providers: [ConfirmationService, MessageService],
})
export class SurveyViewComponent {
  @ViewChildren('questionDiv') questionDivs: QueryList<any> = new QueryList();
  centerPosition: any;

  //Network IP or Domain
  staticFileUrl = GlobalConstants.staticFilesURL;

  //loading
  skelition: boolean = true;

  days: number[] = Array.from({ length: 31 }, (_, i) => i + 1);
  months: number[] = Array.from({ length: 12 }, (_, i) => i + 1);
  years: number[] = Array.from(
    { length: 100 },
    (_, i) => new Date().getFullYear() - i
  );

  //Survey data
  survey: any;
  surveyAssessmentId: any;
  questions: any[] = [];
  conditionalQuestions: any[] = [];
  currentQuestionIndex: number = -1;
  currentQuestion: any;
  submitted: boolean = false;
  from: string = 'survey';
  isAssessment: boolean = false;
  //Access Type Account Validations
  invalid: boolean = false;
  isExternal: boolean = false;
  isUserTesting: boolean = false;
  externalEmail: string = '';
  validationMessage: string = '';

  translator: TranslatorPipeStandAlone = new TranslatorPipeStandAlone();

  //Complition percentage
  completed: number = 0;

  //Popup messages
  messages: any[] = [];
  answerError: boolean = false;

  headingQuestions: string[] = [
    'PRESENTATION_TEXT',
    'SECTION_HEADING',
    'SECTION_SUB_HEADING',
  ];
  filteredQuestions: any[] = [];
  addHeadingIndex: number = 0;
  nextHeadingIndex: number = 0;
  oldHeadingIndex: number = 0;
  prevCurrentIndex: number = 0;
  courseId: string = '';
  ratingFor: string = '';
  ratingForID: string = '';
  isMainTrainer: boolean = false;
  isRating: boolean = false;
  startError: boolean = false;
  isManager: boolean = false;
  isTrainer: boolean = false;
  isImpactSurvey: boolean = false;
  classicQuestions: any;

  userId: any;

  constructor(
    private activeRoute: ActivatedRoute,
    private dataService: DataService,
    private confirmationService: ConfirmationService,
    public location: Location,
    private messageService: MessageService
  ) {}

  ngOnInit() {

    this.activeRoute.queryParams.subscribe((qParams) => {
      if (qParams['userId'] && qParams['forTrainer']) {
        this.userId = qParams['userId'];
        this.isTrainer = true;
        this.isImpactSurvey = true;
      }

      if (qParams['userId'] && qParams['formManager']) {
        this.userId = qParams['userId'];
        this.isManager = true;
        this.isImpactSurvey = true;
      }

      if (qParams['courseId']) {
        this.courseId = qParams['courseId'];
      }

      if (qParams['ratingFor']) {
        this.ratingFor = qParams['ratingFor'];
        this.isRating = true;
      }

      if (qParams['ratingForID']) {
        this.ratingForID = qParams['ratingForID'];
        this.isRating = true;
      }

      if (qParams['ratingForID']) {
        this.ratingForID = qParams['ratingForID'];
        this.isRating = true;
      }

      if (qParams['isMainTrainer']) {
        this.isMainTrainer = qParams['isMainTrainer'] == 'true' ? true : false;
        this.isRating = true;
      }

      if (qParams['external'] == 1) {
        this.isExternal = true;
        this.externalEmail = qParams['email'];
      }

      if (qParams['userTesting'] == 1) {
        this.isUserTesting = true;
      }
    });
    this.activeRoute.params.subscribe((params) => {
      this.surveyAssessmentId = params['surveyId'];
      this.from = params['from'];

      let url: string = '/sa/' + this.from + '/attempt/' + this.surveyAssessmentId;
      window.open(`${url}`, '_blank');

      
      if (this.from == 'assessment') {
        this.isAssessment = true;
      }
      if (this.surveyAssessmentId && this.from) {
        if (this.survey == undefined) {
          this.getData();
        }
      } else {
        this.skelition = false;
        this.invalidate('Invalid params');
      }
      if (
        this.courseId &&
        !this.isUserTesting &&
        !this.isRating &&
        !this.isImpactSurvey
      ) {
        this.checkUserinCourse();
      }

      if (this.courseId && !this.isUserTesting && this.isRating) {
        this.checkUserinRating();
      }
    });
  }

  QuestionsUpdated() {
    if (this.survey?.settings?.displayMode == 'Classic' && !this.isAssessment) {
      this.ngOnInit();
    }
  }

  checkUserLogin() {
    return localStorage.getItem('isLoggedIn') == 'true';
  }

  async checkUserinCourse() {
    try {
      this.skelition = true;
      let uid = localStorage.getItem('uid');
      let url = `course/checkuser/${this.courseId}/${uid}/${this.surveyAssessmentId}/${this.from}`;
      let res = await this.dataService.getData(url);
      this.skelition = false;
      if (res.error) {
        this.messages = [
          {
            severity: 'error',
            summary: this.translate('error'),
            detail: res.msg,
          },
        ];
        this.skelition = false;
        this.invalidate(this.translate('No data found'));
        return;
      }
      if (this.from == 'survey') {
        if (res.data[0].isUserIn == false && res.data[0].isSurveyIn == false) {
          this.invalidate(this.translate('User not in Course'));
          return;
        }
      } else if (this.from == 'assessment') {
        if (
          res.data[0].isUserIn == false &&
          res.data[0].isAssessmentIn == false
        ) {
          this.invalidate(this.translate('User not in Course'));
          return;
        }
      }
    } catch (e) {
      this.invalidate('Failed to fetch attempt status');
    }
  }

  async checkUserinRating() {
    try {
      this.skelition = true;
      let uid = localStorage.getItem('uid');
      let data: any = {
        courseId: this.courseId,
        uid: uid,
        ratingFor: this.ratingFor,
        isMainTrainer: this.isMainTrainer,
      };
      let url = `course/checkrating`;
      let res = await this.dataService.postData(url, data);
      this.skelition = false;
      if (res.error) {
        this.messages = [
          {
            severity: 'error',
            summary: this.translate('error'),
            detail: res.msg,
          },
        ];
        this.skelition = false;
        this.invalidate(this.translate('No data found'));
        return;
      }
      if (res.data == false) {
        this.invalidate(this.translate('You are not allowed for rating'));
        return;
      }
    } catch (e) {
      this.invalidate(this.translate('Failed to fetch rating status'));
    }
  }

  async checkIfAttempted(email: string) {
    try {
      this.skelition = true;
      let url = `${this.from}-attempt/check/${email}/${this.surveyAssessmentId}`;
      let res = await this.dataService.getData(url);
      this.skelition = false;
      if (res.data) {
        if (this.from == 'survey' && !this.courseId) {
          this.invalidate(this.translate('You have attempted this survey'));
        } else if (this.from == 'assessment' && !this.courseId) {
          this.invalidate(this.translate('You have attempted this assessment'));
        }
      }
    } catch (e) {
      this.invalidate('Failed to fetch attempt status');
    }
  }

  //On Scroll Focus Logic
  @HostListener('window:scroll', ['$event'])
  onScroll(event: Event) {
    if (this.survey?.settings?.displayMode == 'Classic') {
      // Calculate the scroll position
      if (this.questionDivs && this.questionDivs.length > 0) {
        const scrollPosition =
          window.scrollY || document.documentElement.scrollTop;

        // Calculate the center of the screen
        const screenHeight =
          window.innerHeight || document.documentElement.clientHeight;
        const screenCenter = screenHeight / 1.5;

        // Determine which question to show based on scroll position and center of the screen
        this.questionDivs.toArray().forEach((questionDiv, index) => {
          const element = questionDiv.questionDiv.nativeElement;
          const elementTop = element.offsetTop;
          const elementHeight = element.clientHeight;
          const elementCenter = elementTop + elementHeight / 2;

          if (
            elementCenter >= scrollPosition &&
            elementCenter <= scrollPosition + screenCenter
          ) {
            this.showQuestion(index);
          }
        });
      }
    }
  }

  @HostListener('click', ['$event'])
  onClick(event: Event) {
    if (this.survey?.settings?.displayMode == 'Classic') {
      // Handle the click event and apply the 'visible' class to the clicked question
      const clickedIndex = this.questionDivs
        .toArray()
        .findIndex((questionDiv) =>
          questionDiv.questionDiv.nativeElement.contains(event.target as Node)
        );

      if (clickedIndex !== -1) {
        this.showQuestion(clickedIndex);
      }
    }
  }

  showQuestion(index: number) {
    // Add a class to the visible question and remove it from others
    this.questionDivs?.forEach((question: any, i: number) => {
      if (i === index) {
        question.questionDiv.nativeElement.classList.remove('unfocus');
        question.questionDiv.nativeElement.classList.add('active-border');
      } else {
        question.questionDiv.nativeElement.classList.remove('active-border');
        question.questionDiv.nativeElement.classList.add('unfocus');
      }
    });
  }

  translate(value: string) {
    return this.translator.transform(value);
  }

  private async getData(): Promise<void> {
    try {
      let res = await this.dataService.getData(
        `${this.from}/id/${this.surveyAssessmentId}`
      );
      if (res.error) {
        this.messages = [
          {
            severity: 'error',
            summary: this.translate('error'),
            detail: res.msg,
          },
        ];
        this.skelition = false;
        this.invalidate(this.translate('No data found'));
        return;
      }
      this.survey = res.data;
      if (!this.courseId) {
        this.checkSurveyValidations();
      }

      if (this.isImpactSurvey) {
        if (this.isManager) {
          this.questions = this.survey.questions.filter(
            (q: any) =>
              (!q.meta.conditional || q.meta.condition.question == null) &&
              q.meta.forManager == true
          );
        } else {
          this.questions = this.survey.questions.filter(
            (q: any) =>
              (!q.meta.conditional || q.meta.condition.question == null) &&
              q.meta.forTrainer == true
          );
        }
        this.classicQuestions = this.questions;
      } else {
        this.classicQuestions = this.survey.questions;
        this.questions = this.survey.questions.filter(
          (q: any) => !q.meta.conditional || q.meta.condition.question == null
        );
        this.conditionalQuestions = this.survey.questions.filter(
          (q: any) => q.meta.conditional && q.meta.condition.question != null
        );
        let rankQuestions = this.questions.filter(
          (q) => q.type == 'RANK_ORDER'
        );
        rankQuestions.forEach((q) => {
          this.getRankDDValues({}, '', q.meta);
        });
      }
      this.skelition = false;
    } catch (e) {
      this.messages = [
        { severity: 'error', summary: this.translate('error'), detail: e },
      ];
    }
  }

  canShowCondQuestion(Question: any): boolean {
    if (this.isAssessment) {
      return true;
    }
    if (Question.meta.conditional && Question.meta.condition.question != null) {
      for (const question of this.survey.questions) {
        const Ans = this.getAnswerProvided(question);
        if (Ans != undefined && Ans.length > 0) {
          const value =
            Question.meta.condition.question.questionCode ==
              question.questionCode &&
            (Question.meta.condition.option.label == Ans ||
              Ans.includes(Question.meta.condition.option.label));
          if (value) {
            return true;
          }
        }
      }
      return false;
    } else {
      return true;
    }
  }

  invalidate(message: string) {
    this.invalid = true;
    this.validationMessage = message;
  }

  addOrRemoveImageFromList(question: any, label: string) {
    if (question.meta.value.includes(label)) {
      let index = question.meta.value.indexOf(label);
      question.meta.value.splice(index, 1);
    } else {
      question.meta.value.push(label);
    }
  }

  checkSurveyValidations() {
    if (this.survey.accessType == 'BY_URL') {
      let email = localStorage.getItem('email');
      if (email) {
        this.survey = { ...this.survey, email };
      }
    }

    if (this.isExternal) {
      let email = this.externalEmail;
      this.survey = { ...this.survey, email };
    }

    if (this.survey.status == 'Pending' && !this.isUserTesting) {
      if (this.from == 'survey') {
        this.invalidate(this.translate('Start Tomorrow Survey'));
      } else {
        this.invalidate(this.translate('Start Tomorrow Assessment'));
      }
      return;
    } else if (this.survey.status == 'Closed' && !this.isUserTesting) {
      if (this.from == 'survey') {
        this.invalidate(this.translate('Survey Closed Error'));
        return;
      } else {
        this.invalidate(this.translate('Assessment Closed Error'));
        return;
      }
    }

    if (this.survey.accessType == 'BY_ACCOUNT') {
      if (this.isExternal) {
        if (!this.externalEmail && !this.isUserTesting) {
          this.invalidate('بريد إلكتروني صالح مفقود.');
          return;
        }
        if (
          !this.survey.externals.includes(this.externalEmail) &&
          !this.isUserTesting
        ) {
          this.invalidate('البريد الإلكتروني المقدم غير صالح.');
          return;
        }
        if (!this.isUserTesting) {
          this.checkIfAttempted(this.externalEmail);
        }
        return;
      }

      // 1. user should be login
      let uid = localStorage.getItem('uid');
      if (!(localStorage.getItem('isLoggedIn') == 'true') || uid == null) {
        this.dataService.storeCurrentStateUrl();
        return;
      }

      // 2. user's id should be available in attendees list
      if (!this.courseId) {
        if (!this.survey.attendees.includes(uid) && !this.isUserTesting) {
          if (this.from == 'survey') {
            this.invalidate('لايمكنك المشاركة في هذا الاستبيان');
            return;
          } else {
            this.invalidate('لايمكنك المشاركة في هذا الاختبار');
            return;
          }
        }
      }
      let email = localStorage.getItem('email');
      if (!this.isUserTesting) {
        this.checkIfAttempted(email!);
      }
    }
  }

  nextQuestion(isPrevious: boolean) {
    if (this.survey.settings.displayMode == 'Classic') {
      if (this.currentQuestionIndex == -1 && !this.submitted) {
        if (!this.isUserTesting) {
          this.checkIfAttempted(this.survey.email);
        }
        this.currentQuestionIndex += 1;
        return;
      }
      if (!this.isAnswerProvided(this.survey.questions)) {
        this.answerError = true;
        this.messageService.add({
          severity: 'error',
          summary: this.translate('error'),
          detail: this.translate(
            'Please Give Answer to all the Following Question'
          ),
        });
        return;
      }
      this.answerError = false;
      this.confirmSubmit();
      return;
    }

    if (
      this.currentQuestionIndex == -1 &&
      !this.submitted &&
      !this.isUserTesting
    ) {
      this.checkIfAttempted(this.survey.email);
    }

    if (this.currentQuestionIndex != -1 && !isPrevious) {
      if (!this.isAnswerProvided(this.currentQuestion)) {
        this.answerError = true;
        this.messageService.add({
          severity: 'error',
          summary: this.translate('error'),
          detail: this.translate(
            'Please Give Answer to all the Following Question'
          ),
        });
        return;
      } else {
        this.answerError = false;
      }
    }

    if (
      !this.isAssessment &&
      this.currentQuestionIndex != -1 &&
      this.survey?.settings?.displayMode == 'Focus' &&
      !isPrevious
    ) {
      this.currentQuestion = [this.questions[this.currentQuestionIndex]];

      let conditionalQuestions: any[] = [];
      for (const question of this.currentQuestion) {
        const answerProvided = this.getAnswerProvided(question);
        if (answerProvided && answerProvided.length > 0) {
          conditionalQuestions = conditionalQuestions.concat(
            this.conditionalQuestions.filter((conditionalQuestion: any) => {
              return (
                conditionalQuestion.meta.condition.question.questionCode ===
                  question.questionCode &&
                (conditionalQuestion.meta.condition.option.label ===
                  answerProvided ||
                  answerProvided.includes(
                    conditionalQuestion.meta.condition.option.label
                  ))
              );
            })
          );
        }
      }

      this.questions = [
        ...this.questions.slice(0, this.currentQuestionIndex + 1),
        ...conditionalQuestions,
        ...this.questions.slice(this.currentQuestionIndex + 1),
      ];
    }

    if (this.currentQuestionIndex == this.questions.length - 1 && !isPrevious) {
      //Submit the test and show thankyou page
      this.currentQuestionIndex += 1;
      this.calculateComplitionPercentage();
      this.confirmSubmit();
      return;
    }

    if (isPrevious) {
      this.currentQuestionIndex -= 1;
    } else {
      this.currentQuestionIndex += 1;
    }

    this.currentQuestion = [this.questions[this.currentQuestionIndex]];
    this.prevCurrentIndex = this.currentQuestionIndex;

    let NextIndex = this.currentQuestionIndex;
    if (this.currentQuestionIndex <= this.questions.length) {
      if (this.headingQuestions.includes(this.questions[NextIndex].type)) {
        if (this.questions.length - 1 == this.currentQuestionIndex) {
          this.currentQuestion = [this.questions[NextIndex]];
        } else {
          this.currentQuestion = [
            this.questions[NextIndex],
            this.questions[NextIndex + 1],
          ];
          this.currentQuestionIndex = this.currentQuestionIndex + 1;
        }
      }
    }
    this.calculateComplitionPercentage();
  }

  isAnswerProvided(questions: any[]): boolean {
    let allAnswersProvided = true;

    questions.every((question) => {
      const fieldsValueTypes = [
        'SINGLE_ROW_TEXT',
        'EMAIL_ADDRESS',
        'COMMENT_BOX',
        'CONTACT_INFO',
        'STAR_RATING',
        'RANK_ORDER',
        'DRAG_DROP',
      ];
      const fieldsFieldValueTypes = ['MULTI_POINT_SCALE'];
      const metaValueTypes = [
        'SELECT_ONE',
        'DROPDOWN_MENU',
        'SELECT_ONE_IMAGE',
        'SMILE_RATING',
        'CALENDAR',
        'OU_TREE_DROPDOWN',
      ];
      const metaValueArrayTypes = ['SELECT_MANY', 'SELECT_MANY_IMAGE'];
      const fieldsValueArrayTypes = ['MULTI_SELECT_SCALE'];
      const dateTypes = ['DATE_TIME'];
      const impactType = ['IMPACT_MEASUREMENT'];

      let answerProvided = false;

      if (!question || !question.type) {
        return true;
      }

      if (this.headingQuestions.includes(question.type)) {
        return true;
      }

      if (!this.isAssessment) {
        if (!this.canShowCondQuestion(question)) {
          return true;
        }
        if (question.meta.validReq == undefined || !question.meta.validReq) {
          return true;
        }
      }

      if (fieldsValueTypes.includes(question.type)) {
        answerProvided =
          question.meta &&
          question.meta.fields &&
          Array.isArray(question.meta.fields) &&
          question.meta.fields.every(
            (field: any) =>
              field.value !== null && field.value.toString().trim() !== ''
          );
      }

      if (impactType.includes(question.type)) {
        answerProvided =
          question.meta &&
          question.meta.empAnswer.toString().trim() !== '' &&
          question.meta.fields &&
          Array.isArray(question.meta.fields) &&
          question.meta.fields.every(
            (field: any) =>
              field.value !== null && field.value.toString().trim() !== ''
          );
      }

      if (fieldsFieldValueTypes.includes(question.type)) {
        answerProvided =
          question.meta &&
          question.meta.fields &&
          Array.isArray(question.meta.fields) &&
          question.meta.fields.every(
            (field: any) =>
              field &&
              field.field &&
              field.field.value !== undefined &&
              field.field.value.toString().trim() !== ''
          );
      }

      if (metaValueTypes.includes(question.type)) {
        answerProvided =
          question.meta &&
          question.meta.value !== null &&
          question.meta.value !== undefined &&
          question.meta.value.toString().trim() !== '';
      }

      if (metaValueArrayTypes.includes(question.type)) {
        answerProvided =
          question.meta &&
          Array.isArray(question.meta.value) &&
          question.meta.value.length > 0;
      }

      if (fieldsValueArrayTypes.includes(question.type)) {
        answerProvided =
          question.meta &&
          question.meta.fields &&
          Array.isArray(question.meta.fields) &&
          question.meta.fields.some(
            (field: any) => Array.isArray(field.value) && field.value.length > 0
          );
      }

      if (dateTypes.includes(question.type)) {
        answerProvided =
          question.meta &&
          typeof question.meta.value === 'object' &&
          question.meta.value !== null &&
          Object.values(question.meta.value).every(
            (val) =>
              (typeof val === 'string' || typeof val === 'number') &&
              val.toString().trim() !== ''
          );
      }

      if (!answerProvided) {
        question.showError = true;
        allAnswersProvided = false;
      } else {
        question.showError = false;
      }
      return answerProvided;
    });
    return allAnswersProvided;
  }

  getAnswerProvided(question: any): any {
    let allAnswersProvided = true;
    const metaValueTypes = [
      'SELECT_ONE',
      'DROPDOWN_MENU',
      'SELECT_ONE_IMAGE',
      'SMILE_RATING',
      'OU_TREE_DROPDOWN',
    ];
    const metaValueArrayTypes = ['SELECT_MANY', 'SELECT_MANY_IMAGE'];
    let answerProvided = false;

    if (!question || !question.type) {
      return true;
    }

    if (metaValueTypes.includes(question.type)) {
      if (
        question.meta &&
        question.meta.value !== null &&
        question.meta.value !== undefined &&
        question.meta.value.toString().trim() !== ''
      ) {
        return question.meta.value;
      }
    }

    if (metaValueArrayTypes.includes(question.type)) {
      if (
        question.meta &&
        Array.isArray(question.meta.value) &&
        question.meta.value.length > 0
      ) {
        return question.meta.value;
      }
    }
  }

  calculateComplitionPercentage() {
    this.completed = Math.floor(
      (this.currentQuestionIndex / this.questions.length) * 100
    );
  }

  validateEmail(email: string) {
    const emailRegex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;
    return emailRegex.test(email);
  }

  async submitSurvey() {
    try {
      if (this.isUserTesting) {
        this.submitted = true;
        this.currentQuestion = null;
        this.currentQuestionIndex = -1;
      } else {
        if (this.isExternal) {
          this.survey.email = this.externalEmail;
        } else if (
          this.survey.accessType == 'BY_ACCOUNT' &&
          !this.survey.email
        ) {
          let email = localStorage.getItem('email');
          if (email) {
            this.survey.email = email;
          }
        }
        if (this.courseId) {
          this.survey.courseId = this.courseId;
        }

        if (this.isRating && !this.isImpactSurvey) {
          this.survey.ratingFor = this.ratingFor;
          this.survey.ratingForID = this.ratingForID;
        }

        if (this.isImpactSurvey) {
          this.survey.attemptFor = this.userId;
        }

        let res = await this.dataService.postData(
          `${this.from}/submit`,
          this.survey
        );
        if (res.error) {
          this.messages = [
            {
              severity: 'error',
              summary: this.translate('error'),
              detail: res.msg,
            },
          ];
          return;
        }
        this.messages = [
          { severity: 'success', summary: this.translate('success') },
        ];
        this.generateResults();
        this.submitted = true;
        this.currentQuestion = null;
        this.currentQuestionIndex = -1;
      }
    } catch (e) {
      this.messages = [
        { severity: 'error', summary: this.translate('error'), detail: e },
      ];
    }
  }

  async generateResults() {
    try {
      let res = await this.dataService.postData(
        `${this.from}-result/generate`,
        ''
      );
    } catch (e) {}
  }

  confirmSubmit() {
    this.confirmationService.confirm({
      message: 'هل أنت متأكد من أنك تريد الإرسال؟',
      header: 'رسالة تأكيد',
      icon: 'pi pi-exclamation-triangle mx-2',
      rejectLabel: 'إلغاء الأمر',
      acceptLabel: 'موافق',
      accept: () => this.submitSurvey(),
      reject: () => {
        if (this.survey?.settings?.displayMode == 'Focus') {
          this.currentQuestionIndex -= 1;
          this.calculateComplitionPercentage();
        }
      },
    });
  }
  selectedProducts: any = [];

  draggedProduct: any;

  dragStart(product: any) {
    this.draggedProduct = product;
  }

  drop(question: any) {
    if (this.draggedProduct) {
      question.meta.orderedFields = [
        ...question.meta.orderedFields,
        this.draggedProduct,
      ];
      question.meta.orderedFields = question.meta.orderedFields.map(
        (field: any, index: number) => {
          return {
            ...field,
            value: String(index + 1),
          };
        }
      );
      question.meta.fields = question.meta.fields.filter(
        (val: any) => val.label != this.draggedProduct.label
      );
      this.draggedProduct = null;
    }
  }

  dragEnd() {
    this.draggedProduct = null;
  }

  getRankDDValues(field: any, value: any, meta: any) {
    let values: any[] = [];

    meta.fields.forEach((metaField: any, i: number) => {
      if (field.label == metaField.label) {
        metaField.value = value;
      }
      values.push({
        label: (i + 1).toString(),
        value: i + 1,
        disabled: metaField.value == i + 1,
      });
    });

    meta.options = this.isAssessment
      ? values
      : [{ label: '-Select-', value: -1, disabled: false }, ...values];
  }

  getRankDDValues2(question: any): string[] {
    let values: string[] = [];

    for (let i = 1; i < question.meta.fields.length + 1; i++) {
      values.push(i.toString());
    }

    return values;
  }

  addRemoveValueInFieldArray(field: any, value: any) {
    if (field.value.includes(value)) {
      field.value = field.value.filter((v: string) => v != value);
      return;
    }
    field.value = [...field.value, value];
  }

  canStart() {
    if (
      (this.survey.accessType == 'BY_URL' &&
        (this.survey.email == null ||
          this.survey.email == undefined ||
          !this.validateEmail(this.survey.email))) ||
      ((this.survey.externalName == null ||
        this.survey.externalName == undefined) &&
        !this.checkUserLogin())
    ) {
      console.log('asdasd');
      this.startError = true;
      this.messageService.add({
        severity: 'error',
        summary: this.translate('error'),
        detail: 'يرجى تعبئة جميع الخانات',
      });
      return false;
    } else {
      this.startError = false;
      this.nextQuestion(false);
      return true;
    }
  }

  numberOnly(event: any): boolean {
    const charCode = event.which ? event.which : event.keyCode;
    if (
      (charCode !== 46 &&
        charCode !== 45 &&
        charCode > 31 &&
        (charCode < 48 || charCode > 57)) ||
      (event.target.value.includes('.') && charCode === 46)
    ) {
      return false;
    }
    return true;
  }
}
